export default function alphanum (event) {
	if (document.documentElement.className.search('mobile')+1) return true;
	if (document.documentElement.className.search('tablet')+1) return true;
	if ((57 >= event.keyCode && event.keyCode >= 48)
      || (122 >= event.keyCode && event.keyCode >= 96)
      || (90 >= event.keyCode && event.keyCode >= 65)
      || (event.keyCode == 8)
      || (event.keyCode == 46)
      || (event.keyCode == 13)
      || (event.keyCode == 32)) {
		return true;
	} else {
		return false;
	}
}



// WEBPACK FOOTER //
// ./public/scripts/webpack/alphanum.js